import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useAuth} from 'hooks/auth/useAuth';
import {showToast} from '@chekinapp/ui';
import {TRUSTED_OAUTH_ORIGINS} from 'utils/constants';

export const useGoogleSignIn = () => {
  const {authenticate} = useAuth();
  const {t} = useTranslation();

  const subscribeOAuthGoogleCompletion = useCallback(
    ({
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: Error) => void;
    }) => {
      const handleMessage = (event: MessageEvent) => {
        if (!TRUSTED_OAUTH_ORIGINS.includes(event.origin)) {
          return;
        }

        const {isLoginSuccessful, isLoginError, accessToken, error} = event.data;

        if (isLoginSuccessful && accessToken) {
          authenticate({token: accessToken});
          onSuccess?.();
          window.removeEventListener('message', handleMessage);
        }

        if (isLoginError) {
          showToast.error(t('auth.google_sign_in_failed'));
          onError?.(error);
          window.removeEventListener('message', handleMessage);
        }
      };

      window.addEventListener('message', handleMessage);

      return {
        unsubscribe: () => {
          window.removeEventListener('message', handleMessage);
        },
      };
    },
    [authenticate, t],
  );

  return {
    subscribeOAuthGoogleCompletion,
  };
};
